import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PortalReviewEffects } from './effects';
import { portalReviewFeatureKey, reducer } from './reducer';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([PortalReviewEffects]),
    StoreModule.forFeature(portalReviewFeatureKey, reducer),
  ],
})
export class PortalReviewModule {}
